<template>
  <v-container>
    <v-row>
      <h1>{{ titol }}</h1>
    </v-row>
    <v-row v-for="(item, index) in ordres" :key="index" class="mb-1">
      <v-col>
        <v-card>
          <v-card-title class="red">
            <v-container>
              <v-row>
                <v-expansion-panels tile flat class="mt-n2">
                  <v-expansion-panel class="red">
                    <v-expansion-panel-header>
                      <div class="text-h6 ml-n6">
                        {{ $t("Ordre") }} {{ item.albara }}
                        <br />
                        {{ item.nom }} ({{ item.client }})
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="text-subtitle-1">
                        <span class="font-weight-bold">{{
                          $t("Adreça:")
                        }}</span>
                        {{ item.domicili }}
                      </div>
                      <div class="text-subtitle-1">
                        <span class="font-weight-bold">{{
                          $t("Població:")
                        }}</span>
                        {{ item.poblacio }}
                      </div>
                      <div class="text-subtitle-1">
                        <span class="font-weight-bold">{{
                          $t("Telefon:")
                        }}</span>
                        {{ item.telefon }}
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <h3 class="mt-2">{{ $t("Feines_a_fer") }}</h3>
            <v-form>
              <v-textarea
                v-if="
                  item.observacionsOrdre != null &&
                  item.observacionsOrdre.trim() != ''
                "
                auto-grow
                rows="1"
                readonly
                :value="item.observacionsOrdre"
                hide-details="auto"
              ></v-textarea>
              <v-text-field
                v-if="item.descripcio != null && item.descripcio.trim() != ''"
                readonly
                :value="item.descripcio"
                hide-details="auto"
              ></v-text-field>
              <v-textarea
                v-if="
                  item.observacionsSubordre != null &&
                  item.observacionsSubordre.trim() != ''
                "
                auto-grow
                rows="1"
                readonly
                :value="item.observacionsSubordre"
                hide-details="auto"
              ></v-textarea>
            </v-form>
            <div v-if="principal == 'S'">
              <h3 class="mt-6">{{ $t("FeinesFetes") }}</h3>
              <v-form>
                <v-textarea
                  v-model="feinesFetes[index]"
                  hide-details="auto"
                ></v-textarea>
              </v-form>
              <!-- llista del material -->
              <h3 class="mt-6">{{ $t("Material") }}</h3>

              <v-data-table
                :headers="[
                  { text: $t('Descripcio'), value: 'descripcio' },
                  { text: $t('Quantitat'), value: 'quantitat', align: 'right' },
                ]"
                :items="material"
                :items-per-page="10"
                :pagination.sync="pagination"
                :loading="loading"
                :loading-text="$t('Carregant')"
                :no-data-text="$t('NoHiHaDades')"
                :no-results-text="$t('NoHiHaResultats')"
                :footer-props="{
                  itemsPerPageOptions: [10, 20],
                  itemsPerPageText: '',
                }"
              >
              </v-data-table>
              <!-- fi llista del material -->
              <v-btn
                class="mt-5"
                @click="entrarMaterial()"
                rounded
                color="blue"
                style="color: white"
                >{{ $t("EntrarMaterial") }}</v-btn
              >
            </div>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-col>
                  <v-btn
                    v-if="principal == 'S'"
                    :disabled="pendentVisible"
                    @click="finalitzarOrdre(item, index, 'S', 'F')"
                    color="green"
                    class="mt-2"
                  >
                    {{ $t("FinalitzarOrdre") }}
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="pendentVisible"
                    @click="finalitzarOrdre(item, index, 'N', '')"
                    color="green"
                    class="mt-2"
                  >
                    {{ $t("FinalitzarFitxada") }}
                  </v-btn>
                  <v-btn
                    v-if="principal == 'S'"
                    @click="pendentVisible = !pendentVisible"
                    color="blue"
                    class="mt-2 ml-2"
                  >
                    {{ $t("DeixarPendent") }}
                    <v-icon v-if="pendentVisible" right dark
                      >mdi-chevron-up</v-icon
                    >
                    <v-icon v-else right dark>mdi-chevron-down</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card flat v-if="pendentVisible">
                    <v-card-text>
                      <!-- llista de motius v-list -->
                      <h3 class="mt-6">{{ $t("Motiu") }}</h3>
                      <v-list>
                        <v-list-item-group v-model="motiu" color="primary">
                          <v-list-item
                            v-for="(item, i) in motius"
                            :key="i"
                            :value="item.id"
                            @click="addObservacionsPendent(index, item.text)"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{
                                item.descripcio
                              }}</v-list-item-title>
                              <v-list-item-subtitle>{{
                                item.text
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>

                      <v-textarea
                        v-model="observacionsPendent[index]"
                        label="Observacions"
                        hide-details="auto"
                      ></v-textarea>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="blue"
                        class="mr-2"
                        @click="deixarPendent(item, index)"
                      >
                        {{ $t("DeixarPendent") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-alert v-model="alertaMotiu[index]" color="red">
                    {{ $t("Cal_triar_un_motiu") }}</v-alert
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-btn class="mt-4" fab @click="enrrera()">
        <v-icon dark>mdi-arrow-left-thick</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import api from "../api.js";
import Cookies from "js-cookie";

export default {
  data: () => ({
    pendentVisible: false,
    ordres: [],
    feinesFetes: [],
    ultMilis: new Date().getTime(),
    alertaMotiu: [],
    motiu: [],
    observacionsPendent: [],
    titol: "",
    material: [],
    motius: [],
    principal: "N",
  }),
  methods: {
    addObservacionsPendent(index, text) {
      this.observacionsPendent[index] = text;
    },
    loadMaterial() {
      this.material = sessionStorage.getItem("systimes.material");
      if (this.material == null) {
        this.material = [];
      } else {
        this.material = JSON.parse(this.material);
      }
    },
    entrarMaterial() {
      this.$store.commit("setBack", "/OrdresPendentsG");
      this.$router.push("MaterialG");
    },
    enrrera() {
      sessionStorage.setItem("systimes.inici", "0");
      this.$router.push("/");
    },
    // Data actual AAAA-MM-DD
    dataActual() {
      var data = new Date();
      var dia = data.getDate();
      var mes = data.getMonth() + 1;
      var any = data.getFullYear();
      if (dia < 10) {
        dia = "0" + dia;
      }
      if (mes < 10) {
        mes = "0" + mes;
      }
      return any + "-" + mes + "-" + dia;
    },
    // Hora actual HH:MM:SS
    horaActual() {
      var data = new Date();
      var hora = data.getHours();
      var minuts = data.getMinutes();
      var segons = data.getSeconds();
      if (hora < 10) {
        hora = "0" + hora;
      }
      if (minuts < 10) {
        minuts = "0" + minuts;
      }
      if (segons < 10) {
        segons = "0" + segons;
      }
      return hora + ":" + minuts + ":" + segons;
    },
    intercanvi(ordre, index, finalitzada, estat) {
      /*
      {
          "canal": 1,
          "any": 2022,
          "diari": 1,
          "albara": 2200001,
          "client": 501,
          "nom": "ACHEDOSOL SUMINISTROS  S.L.",
          "domicili": "BUIGAS, 38",
          "poblacio": "ESTEPONA",
          "telefon": "0034-952 804 696",
          "descripcio": "feina a fer per aquesta ordre\r\nper exemple arreglar una pisicina",
          "principal": "S",
          "idPresencia": 54153
      }
      {
        "idx": 0,
        "article": "APR00002",
        "quantitat": 12.2
      }
      */
      var dataFitxada = {
        accio: "FITXADA",
        canal: ordre.canal,
        diari: ordre.diari,
        any: ordre.any,
        ordre: ordre.albara,
        operari: Number(Cookies.get("idOperari")),
        dataInici: sessionStorage.getItem("systimes.dataIniciOrdre"),
        horaInici: sessionStorage.getItem("systimes.horaIniciOrdre"),
        dataFi: this.dataActual(),
        horaFi: this.horaActual(),
        feinaFeta: this.feinesFetes[index],
      };
      var dataFinalitzacio = {
        accio: "FINALITZACIO",
        canal: ordre.canal,
        diari: ordre.diari,
        any: ordre.any,
        ordre: ordre.albara,
        operari: Number(Cookies.get("idOperari")),
        motiuNoFinalitzacio: this.observacionsPendent[index],
        ordreFinalitzada: estat == "P" ? "N" : "S",
      };
      
      console.log("--------------------");
      console.log(this.observacionsPendent[index]);
      console.log("--------------------");

      var dataMaterial = {
        canal: ordre.canal,
        diari: ordre.diari,
        any: ordre.any,
        ordre: ordre.albara,
        operari: Number(Cookies.get("idOperari")),
        material: JSON.parse(sessionStorage.getItem("systimes.material")),
      };
      /*
      // multiple axios post per dataFitxada i dataFinalitzacio
      const requestOne = axios.post(
        api.URL() + "/api/v1/intercanviG",
        dataFitxada
      );
      const requestTwo = axios.post(
        api.URL() + "/api/v1/intercanviG",
        dataFinalitzacio
      );
      const requestThree = axios.post(
        api.URL() + "/api/v1/entrarMaterialG",
        dataMaterial
      );

      // TODO comprovar si cal fer el segon post
      if (finalitzada == "N") {
        axios
          .all([requestOne, requestThree])
          .then(
            axios.spread((...responses) => {
              const responseOne = responses[0];
              const responseThree = responses[1];

              console.log(responseOne);
              console.log(responseThree);

              sessionStorage.removeItem("systimes.material");
              sessionStorage.removeItem("systimes.dataIniciOrdre");
              sessionStorage.removeItem("systimes.horaIniciOrdre");
              sessionStorage.removeItem("systimes.ordre");
            })
          )
          .catch((errors) => {
            console.log(errors);
          });
      } else {
        axios
          .all([requestOne, requestTwo, requestThree])
          .then(
            axios.spread((...responses) => {
              const responseOne = responses[0];
              const responseTwo = responses[1];
              const responseThree = responses[2];

              console.log(responseOne);
              console.log(responseTwo);
              console.log(responseThree);

              sessionStorage.removeItem("systimes.material");
              sessionStorage.removeItem("systimes.dataIniciOrdre");
              sessionStorage.removeItem("systimes.horaIniciOrdre");
              sessionStorage.removeItem("systimes.ordre");
            })
          )
          .catch((errors) => {
            console.log(errors);
          });
      }
      */

      axios
        .post(api.URL() + "/api/v1/intercanviG", dataFitxada)
        .then((response) => {
          console.log(response);
          if (finalitzada == "N") {
            axios
              .post(api.URL() + "/api/v1/entrarMaterialG", dataMaterial)
              .then((response) => {
                console.log(response);
                sessionStorage.removeItem("systimes.material");
                sessionStorage.removeItem("systimes.dataIniciOrdre");
                sessionStorage.removeItem("systimes.horaIniciOrdre");
                sessionStorage.removeItem("systimes.ordre");
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            axios
              .post(api.URL() + "/api/v1/intercanviG", dataFinalitzacio)
              .then((response) => {
                console.log(response);
                axios
                  .post(api.URL() + "/api/v1/entrarMaterialG", dataMaterial)
                  .then((response) => {
                    console.log(response);
                    sessionStorage.removeItem("systimes.material");
                    sessionStorage.removeItem("systimes.dataIniciOrdre");
                    sessionStorage.removeItem("systimes.horaIniciOrdre");
                    sessionStorage.removeItem("systimes.ordre");
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    eventSortida(lat, lng, ordre) {
      var estat;
      console.log("Entrada...");
      this.error = false;
      axios
        .post(api.URL() + "/api/v1/event", {
          id: Number(Cookies.get("idOperari")),
          tipus: "F",
          tipusFitxada: parseInt(
            sessionStorage.getItem("systimes.tipusFixada")
          ),
          lat: lat,
          lng: lng,
          ordre: ordre.albara.toString(),
          idPresencia: ordre.idPresencia,
        })
        .then((response) => {
          var d = new Date();
          var time =
            d.getHours().toString().padStart(2, "0") +
            ":" +
            d.getMinutes().toString().padStart(2, "0");
          this.seconds = d.getSeconds().toString().padStart(2, "0");

          estat = "Final ordre " + response.data + " " + time;

          sessionStorage.setItem("systimes.estat", estat);
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
          this.tipusFitxada = 0;
          this.desactivarFi = false;
          if (err.response.status == 401) {
            if (Cookies.get("idioma") == "Català") {
              this.estat = "Usuari no autoritzat";
            } else {
              this.estat = "Usuario no autorizado";
            }
          } else if (err.response.status == 409) {
            if (Cookies.get("idioma") == "Català") {
              this.estat =
                "Presència ignorada per marge de temps amb una altra presència a les " +
                err.response.data;
            } else {
              this.estat =
                "Presencia ignorada por margen de tiempo con otra presencia a las" +
                err.response.data;
            }
          } else {
            if (Cookies.get("idioma") == "Català") {
              this.estat = "Error connectant amb el servidor";
            } else {
              this.estat = "Error conectando con el servidor";
            }
          }

          this.$router.push("/");
        });
    },

    deixarPendent(ordre, index) {
      this.finalitzarOrdre(ordre, index, "S", "P");
    },

    finalitzarOrdre(ordre, index, finalitzar, estat) {
      var milis = new Date().getTime();
      console.log(milis, this.ultMilis);
      if (milis - this.ultMilis > 1000) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.eventSortida(
                position.coords.latitude,
                position.coords.longitude,
                ordre
              );
              console.log(position);
            },
            (error) => {
              console.log(error);
              this.eventSortida(0, 0, ordre);
            }
          );
        } else {
          this.eventSortida(0, 0, ordre);
        }
      }
      this.ultMilis = new Date().getTime();

      this.intercanvi(ordre, index, finalitzar, estat);
    },
  },
  created() {
    axios
      .post(api.URL() + "/api/v1/ordresPendents", {
        id: Number(Cookies.get("idOperari")),
      })
      .then((response) => {
        this.ordres = response.data;

        if (this.ordres.length == 0) {
          this.titol = this.$t("ResPerFinalitzar");
        } else {
          this.titol = this.$t("Finalitzar");
          this.principal = this.ordres[0].principal;
        }

        this.ordres.forEach((ordre, index) => {
          this.alertaMotiu[index] = false;
        });
        this.loadMaterial();
        // Carregar motius de no finalitzacio
        axios
          .get(api.URL() + "/api/v1/motiusNoFinalitzacioG")
          .then((response) => {
            this.motius = response.data;
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch(() => {
        this.titol = this.$t("ResPerFinalitzar");
      });
  },
};
</script>
